import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles({
  root: {
    "& > *,& > ul > li > *": {
      textAlign: "justify",
      textJustify: "inter-word",
      fontSize: 14,
      fontFamily: "Times New Roman, Times, serif",
    },
    "& > strong": {
      display: "inline-block",
    },
  },
});

export const PrivacyPoliciesTerms = () => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <div style={{ textAlign: "center" }}>
        <strong>
          POLÍTICA DE PRIVACIDADE
        </strong>
      </div>

      <br />

      <p>
        A <strong>Karsten S.A.</strong> (“Karsten” ou “Empresa”), sociedade 
        anônima de capital aberto, inscrita no CNPJ n.º 82.640.558/0001-04, 
        possui o compromisso de proteger e respeitar a privacidade de todos 
        os titulares com os quais se relaciona, e, atuar em conformidade com 
        a Lei Geral de Proteção de Dados (“Lei Federal n.º 13.709/2018” ou 
        “LGPD”). Dessa forma, esta Política de Privacidade possui a finalidade
        de esclarecer a utilização, armazenamento e tratamento das informações
        pessoais (“Dados Pessoais”) obtidas através do Aplicativo <strong>App 
        do Lojista</strong> (“Aplicativo”).
      </p>

      <p>
        A Karsten dispõe de Políticas de Privacidade disponibilizadas nos seus 
        sites, disponíveis para os consumidores finais e público em geral, 
        que fazem parte integrante desta Política:
      </p>

      <ul>
        <li>
          <p>
            (a)&ensp;&ensp;&ensp;&ensp;<strong>Política de Privacidade da 
            Karsten</strong>, disponível para download no endereço:&ensp;
            <a target="_blank" rel="noreferrer"
              href="https://www.karsten.com.br/Institucional/Ajuda/politica-privacidade">
            www.karsten.com.br/Institucional/Ajuda/politica-privacidade</a>;
          </p>
        </li>
      </ul>

      <ul start="2">
        <li>
          <p>
            (b)&ensp;&ensp;&ensp;&ensp;<strong>Política de Privacidade da 
            Trussardi</strong>, disponível para download no endereço:&ensp;
            <a target="_blank" rel="noreferrer"
              href="https://www.trussardi.com.br/institucional/ajuda/politica-de-privacidade">
            www.trussardi.com.br/institucional/ajuda/politica-de-privacidade</a>;
          </p>
        </li>
      </ul>

      <p style={{display:'flex', alignItems:"center", justifyContent:'center', marginTop:'1.5rem'}}>
        QUAL O OBJETO DESTA POLÍTICA DE PRIVACIDADE?
      </p>

      <p>
        Essa política é referente ao tratamento de Dados Pessoais que 
        identifiquem ou sejam capazes de identificar os prepostos dos 
        representantes comerciais e/ou lojistas (“Usuários”) e dos 
        consumidores finais adicionados no Aplicativo.
      </p>

      <p style={{
        display:'flex', 
        alignItems:"center", 
        justifyContent:'center', 
        textAlign:'center'
      }}>
        QUAIS DADOS PESSOAIS TRATAMOS E PARA QUAIS FINALIDADES?
      </p>

      <p>
        Durante a experiência dos Usuários no Aplicativo, a Karsten coleta os 
        Dados Pessoais de três formas: (i) informações fornecidas pelos 
        prepostos dos Usuários; (ii) informações coletadas pelos Usuários do
        consumidor final dos produtos da Karsten, comercializados pelos 
        Usuários e adicionados por estes últimos no Aplicativo; e, (iii) 
        informações coletadas automaticamente quando os Usuários entram no
        Aplicativo.
      </p>

      <p>
        Prezando pela transparência e privacidade dos envolvidos, encontram-se 
        abaixo quais dados e as finalidades para as quais a Karsten trata 
        Dados Pessoais:
      </p>

      <table style={{border:'1px solid grey', width:'100%'}}>
        <tr style={{
          backgroundColor:'rgba(0,0,0,0.9)', 
          color:'white', 
          textAlign:'center'
        }}>
          <th style={{width:'50%'}}>Dados Pessoais</th>
          <th>Finalidades</th>
        </tr>
        <tr style={{border:'1px solid grey'}}>
          <td style={{
            border:'1px solid grey', 
            padding:'0.25rem 0.75rem 0 0.25rem'
          }}>
            <strong>Dados de Cadastro</strong>
            <ul>
              <li>
                <span>
                  Nome
                </span>
              </li>
              <li>
                <span>
                  E-mail
                </span>
              </li>
              <li>
                <span>
                  Cargo
                </span>
              </li>
              <li>
                <span>
                  Telefone
                </span>
              </li>
            </ul>
            <p></p>
            <span>
              *Dados Pessoais dos prepostos dos Usuários (representantes 
              comerciais e/ou lojistas). *Além dos dados acima, para a realização 
              do cadastro, é necessário informar dados da pessoa jurídica - 
              Usuário - que não são considerados como Dados Pessoais de acordo 
              com a LGPD.
            </span>
          </td>
          <td style={{
            display:'flex', 
            alignItems:'center', 
            flexDirection:'column',
            padding:'0.25rem 0.75rem 0 0.25rem',
          }}>
            <span style={{marginBottom:'1rem'}}><strong>Identificação e autenticação do Usuário!</strong></span>
            <span style={{marginBottom:'1rem'}}>
              <strong>Atendimento às solicitações:</strong> para atendimento
              dos Usuários.
            </span>
            <span>
              <strong>Execução do contrato:</strong> para o uso pleno dos
              módulos constantes no Aplicativo.
            </span>
          </td>
        </tr>
        <tr style={{border:'1px solid grey'}}>
          <td style={{
            padding:'0.25rem 0.75rem 0 0.25rem',
            display: 'flex',
            flexDirection:'column',
            alignItems:'flex-start'
          }}>
            <strong>Dados dos Consumidores Finais</strong>
            <ul>
              <li>
                <span>
                  Nome
                </span>
              </li>
              <li>
                <span>
                  CPF
                </span>
              </li>
              <li>
                <span>
                  E-mail
                </span>
              </li>
              <li>
                <span>
                  Telefone
                </span>
              </li>
              <li>
                <span>
                  Endereço
                </span>
              </li>
            </ul>
            <p></p>
            <span>
              *Dados Pessoais fornecidos pelo Usuário no cadastro do cliente e 
              venda de Prateleira Infinita.
            </span>
            <p></p>
          </td>
          <td style={{
            padding:'0.25rem 0.75rem 0 0.25rem',
            border:'1px solid grey', 
          }}>
            <span style={{marginBottom:'1rem'}}>
              <strong>Execução do contrato:</strong> para o uso pleno dos
                módulos constantes no Aplicativo.
            </span>
            <p></p>
            <span style={{marginBottom:'1rem'}}>
              <strong>Prestação de serviços:</strong> para realização do
                cadastro do consumidor final no Aplicativo, para
                processamento do(s) pedido(s) de produto(s) da Karsten, 
                intermediado pelo Usuário.
            </span>
            <p></p>
            <span>
              <strong>Cumprir com a legislação:</strong> para estar em
                conformidade com as obrigações legais e
                regulatórias, por exemplo, para a emissão de
                Notas Fiscais.
            </span>
          </td>
        </tr>
      </table>

      <p></p>

      <p>
        A Karsten ainda pode utilizar as informações fornecidas pelo Usuário
        para criar Dados Agregados, tais como dados estatísticos ou 
        demográficos. Nesse ponto, cumpre destacar que a Karsten tem o
        compromisso proteger e respeitar a privacidade dos envolvidos, 
        sendo que, embora tais Dados Agregados possam ter origem dos Dados 
        Pessoais, eles não são considerados Dados Pessoais segundo a LGPD, 
        visto que serão anonimizados. Ainda, a Karsten pode utilizar certas 
        tecnologias para coleta de informações de navegações dentro do 
        Aplicativo, de forma automatizada e anonimizada, para a Karsten 
        melhorar a experiência do Usuário no Aplicativo.
      </p>

      <p style={{display:'flex', alignItems:"center", justifyContent:'center'}}>
        COMPARTILHAMOS OS DADOS COM TERCEIROS?
      </p>

      <p>
        A Karsten coleta os Dados Pessoais, mas não os vende ou 
        comercializa. Realiza o compartilhamento dos Dados Pessoais 
        somente nas hipóteses abaixo:
      </p>

      <p></p>

      <table style={{border:'1px solid grey', width:'100%'}}>
        <tr style={{border:'1px solid grey'}}>
          <td style={{
            padding:'0.25rem 0.75rem 0 0.25rem',
            display: 'flex',
            alignItems:'center',
            justifyContent:'flex-start',
            width: '100%'
          }}>
            <strong>Terceiros e Prestadores de Serviços</strong>
            <p></p>
          </td>
          <td style={{
            padding:'0.25rem 0.75rem 0 0.25rem',
            border:'1px solid grey', 
            width: '60%'
          }}>
            <span>
              Para atender aos clientes, a Empresa conta com alguns
              fornecedores e empresas parceiras. Dessa forma, a Karsten
              poderá compartilhar os Dados Pessoais, por exemplo, com
              empresas transportadoras, de modo que os produtos
              cheguem na casa dos consumidores finais.
              Esses terceiros têm acesso apenas aos Dados Pessoais
              essenciais para o desempenho de suas funções e não
              poderão utilizar os referidos dados para outras finalidades
              contrárias aos serviços prestados. Além disso, os terceiros
              prestadores de serviço que a Karsten trabalha devem tratar
              os Dados Pessoais nos mesmos termos desta Política de
              Privacidade, nas Políticas de Privacidade constantes nos
              nossos sites, e conforme permitido pela LGPD.
            </span>
            <p></p>
          </td>
        </tr>
        <tr style={{border:'1px solid grey'}}>
          <td style={{
            padding:'0.25rem 0.75rem 0 0.25rem',
            display: 'flex',
            alignItems:'center',
            justifyContent:'flex-start',
            width: '100%'
          }}>
            <strong>Obrigação legal </strong>
            <p></p>
          </td>
          <td style={{
            padding:'0.25rem 0.75rem 0 0.25rem',
            border:'1px solid grey', 
            width: '60%'
          }}>
            <span>
              Quando e se a Karsten for obrigada a cumprir alguma
              legislação, regulamentação, ordem judicial ou
              administrativa ou solicitação governamental aplicável,
              poderá compartilhar os Dados Pessoais.
              Caso ocorra alguma violação de direitos autorais, direitos
              fundamentais, direitos à honra e a imagem, poderá
              compartilhar os Dados Pessoais para contribuição do
              processo investigativo. Ainda, poderá compartilhar em caso
              de fraude, falhas de segurança ou problemas técnicos.
            </span>
            <p></p>
          </td>
        </tr>
        <tr style={{border:'1px solid grey'}}>
          <td style={{
            padding:'0.25rem 0.75rem 0 0.25rem',
            display: 'flex',
            alignItems:'center',
            justifyContent:'flex-start',
            width: '100%'
          }}>
            <strong>Grupo econômico Karsten</strong>
            <p></p>
          </td>
          <td style={{
            padding:'0.25rem 0.75rem 0 0.25rem',
            border:'1px solid grey', 
            width: '60%'
          }}>
            <span>
              A Karsten poderá compartilhar os Dados Pessoais com
              outros núcleos de atividades da Empresa que possam atuar
              junto na execução das suas atividades e na venda dos
              produtos.
            </span>
            <p></p>
          </td>
        </tr>
        <tr style={{border:'1px solid grey'}}>
          <td style={{
            padding:'0.25rem 0.75rem 0 0.25rem',
            display: 'flex',
            alignItems:'center',
            justifyContent:'flex-start',
            width: '100%'
          }}>
            <strong>Com o consentimento </strong>
            <p></p>
          </td>
          <td style={{
            padding:'0.25rem 0.75rem 0 0.25rem',
            border:'1px solid grey', 
            width: '60%'
          }}>
            <span>
              Quando e se obtiver o consentimento livre, específico,
              informado e inequívoco do titular, compartilhará os Dados
              Pessoais com pessoas e organizações que não estejam
              identificadas nesta Política de Privacidade.
            </span>
            <p></p>
          </td>
        </tr>
      </table>

      <p></p>

      <p style={{display:'flex', alignItems:"center", justifyContent:'center'}}>
        COMO PROTEGEMOS OS DADOS PESSOAIS?
      </p>

      <p>
        É responsabilidade da Karsten cuidar dos Dados Pessoais e utilizá-los
        apenas para as finalidades previstas nesta Política de Privacidade 
        e/ou nas Políticas de Privacidade disponibilizadas nos sites da  
        Karsten, garantindo transparência ao titular de dados. Para tanto, 
        a Karsten adota medidas de segurança adequadas, tais como uso de 
        técnicas de criptografia e outros sistemas de segurança da informação, 
        para evitar que os Dados Pessoais sejam extraviados, utilizados, 
        alterados, divulgados ou acessados de forma não autorizada.
      </p>

      <p>
        A Karsten se empenha em proteger as informações, mas infelizmente
        a transmissão de informações pela internet não é totalmente segura. 
        Dessa forma, é importante que os Usuários adotem boas práticas
        de segurança em relação a sua senha e aos seus dispositivos 
        (tais como, mas não se limitando: computadores, celulares etc.). 
        Caso seja identificado ou o Usuário tome conhecimento de alguma ação
        que possa comprometer a segurança dos dados, deverá entrar em contato
        com a Karsten através da Central de Relacionamento (Portal do Lojista), 
        nos canais elencados no link <a target="_blank" rel="noreferrer"
        href="https://www.karstensa.com.br/portal-do-lojista/">
          www.karstensa.com.br/portal-do-lojista/
        </a>.
      </p>

      <p style={{display:'flex', alignItems:"center", justifyContent:'center'}}>
        POR QUANTO TEMPO MANTEMOS OS DADOS?
      </p>

      <p>
        Retemos os Dados Pessoais pelo tempo necessário para cumprir a 
        finalidade pela qual eles foram coletados, inclusive para fins de 
        cumprimento de quaisquer obrigações legais, contratuais, de prestação 
        de contas, requisição de autoridades competentes e durante os prazos 
        prescricionais aplicáveis.
      </p>

      <p>
        Em algumas situações a Karsten poderá anonimizar os Dados Pessoais, 
        de modo que eles não sejam mais associados ao titular, para fins de 
        estatística e pesquisa. Nesta hipótese, poderá utilizar os dados
        anonimizados sem a necessidade de notificação
      </p>

      <p style={{display:'flex', alignItems:"center", justifyContent:'center'}}>
        QUAIS SÃO OS DIREITOS DOS TITULARES DE DADOS PESSOAIS?
      </p>

      <p>O titular de Dados Pessoais segundo a LGPD, tem direito de, a 
        qualquer momento: 
      </p>

      <ul>
        <li>
          <span>
            Acessar os seus Dados Pessoais;
          </span>
        </li>
        <li>
          <span>
            Confirmar a existência de tratamento dos seus Dados Pessoais;
          </span>
        </li>
        <li>
          <span>
            Retificar e corrigir os seus Dados Pessoais;
          </span>
        </li>
        <li>
          <span>
            Excluir os seus Dados Pessoais;
          </span>
        </li>
        <li>
          <span>
            Opor-se ao tratamento dos seus Dados Pessoais;
          </span>
        </li>
        <li>
          <span>
            Solicitar a portabilidade dos seus Dados Pessoais;
          </span>
        </li>
        <li>
          <span>
            Requerer a anonimização, bloqueio ou eliminação dos dados pessoais 
            desnecessários, excessivos ou tratados em desconformidade
            com a legislação;
          </span>
        </li>
        <li>
          <span>
            Retirar o consentimento; e
          </span>
        </li>
        <li>
          <span>
            Solicitar informação sobre o compartilhamento dos seus Dados Pessoais.
          </span>
        </li>
      </ul>

      <p>
        Caso um titular deseje exercer qualquer um desses direitos, 
        deverá entrar em contato pelo e-mail <a 
        href="mailto:dpo@karsten.com.br">dpo@karsten.com.br</a>, 
        administrado pelo Oficial de Proteção de Dados Pessoais da Karsten. 
        Para tanto, a Empresa pode solicitar algumas informações adicionais, 
        que serão utilizadas exclusivamente para fins de verificação da identidade.
      </p>
     
      <p style={{
        display:'flex', 
        alignItems:"center", 
        justifyContent:'center', 
        textAlign:'center'
      }}>
        O QUE MAIS O USUÁRIO PRECISA SABER SOBRE ESSA POLÍTICA DE PRIVACIDADE?
      </p>

      <p>
        <strong>Atualizações da Política de Privacidade e Notificações: </strong>
        Com o intuito de melhorar as políticas e a proteção dos Dados Pessoais, 
        essa Política de Privacidade poderá ser atualizada a exclusivo critério 
        da Karsten e a qualquer tempo. Desta forma, recomenda-se que o Usuário 
        consulte periodicamente o Aplicativo para ter conhecimento sobre as 
        modificações que refletem as melhorias realizadas. 
      </p>

      <p>
        <strong>Contato: </strong>
        Caso exista alguma dúvida sobre esta Política de Privacidade, ou 
        qualquer informação referente ao tratamento de Dados Pessoais, ou, 
        ainda, em caso de outros comentários ou sugestões relacionadas a 
        esta Política de Privacidade, o Usuário deverá entrar em contato 
        através do e-mail <a href="mailto:dpo@karsten.com.br">
        dpo@karsten.com.br</a>, administrado pelo Oficial de Proteção de 
        Dados da Empresa.
      </p>

      <p>
        <strong>Nulidade Parcial: </strong>
        Na hipótese de qualquer disposição desta Política de Privacidade vir 
        a ser declarada nula por qualquer motivo, tal disposição não afetará 
        as demais disposições, as quais continuarão em vigor e produzindo 
        seus efeitos. 
      </p>

      <p>
        <strong>Tolerância: </strong>
        A omissão ou tolerância da Karsten em exigir o estrito cumprimento 
        das condições desta Política de Privacidade não constitui, em nenhuma 
        hipótese, novação ou renúncia, nem impede que a Karsten exerça esses
        direitos a qualquer tempo.
      </p>

      <p>
        <strong>Acontecimentos fora de nosso controle: </strong>
        A Karsten não se responsabiliza por quaisquer descumprimentos ou 
        atrasos nas obrigações assumidas, quando causados por atos, eventos, 
        falhas, omissões ou acidentes que estejam além do seu controle razoável
        ("Força Maior"), conforme legalmente previsto.
      </p>

      <p>
        <strong>Legislação e Foro: </strong>
        Essa Política é regida pela legislação brasileira. Fica eleito o Foro
       da Comarca de Blumenau, estado de Santa Catarina, como o competente para
       dirimir quaisquer questões porventura oriundas da presente Política.
      </p>

      <p>Data: 04 de abril de 2022</p>

      <br />
    </div>
  );
};
